/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import PurchaseIcon from "../../../../../assets/images/icon_menus/PurchaseIcon.json";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import {
    Button, TextField, Box, Switch, FormControlLabel, Tooltip, IconButton, FormControl, FormLabel, RadioGroup, Radio,
} from "@mui/material";
import { SelectedIcon, UnSelectedIcon } from "../../../../Shared/components/Icons/selectedIcon";
import { Col, Row, Image } from "antd";
import Typography from '@mui/material/Typography';
import { useParams } from "react-router-dom";
import crudActions from "../../../../CRUD/redux/actions";
import addressActions from "../../../../Admin/Address/redux/actions";
import groupActions from "../../../Setup/redux/actions";
import gstActions from "../../../../Admin/Setup/redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import { toast } from 'react-toastify';
import { customerTypeList, classificationList, PurchasePriceHead } from "../../../../../config/constant";
import productActions from "../../../../Product/Product/redux/actions";
import PurchasePrice from "../../../../Product/Setup/components/Price/PurchasePrice";
import actions from "../../redux/actions";
import {
    emptyValidation, customEmailValidation,
    customAlaphaNumericValidation, customAlaphaNumericValidationOptional
} from "../../../../../helpers/validation";
import { QuickLinks } from "../../../../Shared/components/BreadCrumbNew/QuickLinks";
import { CustomAccordion } from "../../../../Shared/components/AccordionComponent";
import qucikLinksActions from "../../../../Dashboard/redux/actions";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { checkCRUDViewPermission, checkCRUDPermission, capitalizeFirstLetter, scrollToError, idNamingConversion } from "../../../../../helpers/utilities";
import CustomAlert from "../../../../Shared/components/CustomAlert";
import { AESEncrypt, AESDecrypt } from "../../../../../helpers/Crypto";
import younoteAdminSetupActions from "../../../../YounoteAdmin/Setup/redux/actions";
import { useEventListener } from "../../../../../helpers/useEventListener";
import infoMarkIcon from "../../../../../assets/images/icon_actions/infoMark.svg";

const SupplierEdit = (props) => {
    const { roleManagement } = useSelector(state => state.authReducer);
    const { areaDetails, languageDetails, pincodeDetails, stateDetails, countryDetails, cityDetails } = useSelector(state => state.addressReducer);
    const { partyGstdetails, currencyDetails, mopDetails, taxCodedetails, cashDiscountDetails, otherTaxesdetails } = useSelector(state => state.adminSetupReducer);
    const { supplierGroupDetails } = useSelector(state => state.purchaseSetupReducer);
    const { readDetails, readLoader, readError, editDetails, editError, editLoader } = useSelector(state => state.crudReducer);
    const dispatch = useDispatch();
    const { history } = props;
    const { supplierId } = useParams();
    const decryptedId = AESDecrypt(supplierId);
    const prevReadDetails = usePrevious(readDetails);
    const { taxType } = useSelector(state => state.younoteAdminSetupReducer);

    const [businessType, setBusinessType] = useState('');
    const [serialNumber, setSerialNumber] = useState('');
    const [name, setName] = useState('');
    const [isHold, setIsHold] = useState(false);
    const [mobile, setMobile] = useState('');
    const [email, setEmail] = useState('');
    const [classification, setClassification] = useState('');
    const [languageId, setLanguageId] = useState('');
    const [groupId, setGroupId] = useState('');
    const [gstCodeId, setGstCodeId] = useState('');
    const [priceIncludesTax, setPriceIncludesTax] = useState(false);
    const [gstin, setGstin] = useState('');
    const [address1, setAddress1] = useState('');
    const [areaId, setAreaId] = useState('');
    const [pincodeId, setPincodeId] = useState('');
    const [stateId, setStateId] = useState('');
    const [identityType, setIdentityType] = useState('');
    const [pan, setPan] = useState('');
    const [cityId, setCityId] = useState('');
    const [countryId, setCountryId] = useState('');
    const [showDetails, setShowDetails] = useState(true);
    const childRef = useRef('');
    const [taxCodeId, setTaxCodeId] = useState('');
    const [tcs, setTcs] = useState(false);
    const [tcsId, setTcsId] = useState('');
    const [tdsId] = useState('');
    const [tds, setTds] = useState(false);
    const [cashDiscountId, setCashDiscountId] = useState('');

    const [contactName, setContactName] = useState('');
    const [tradingName, setTradingName] = useState('');
    const [alternateMobile, setAlternateMobile] = useState('');
    const [mopId, setMopId] = useState('');
    const [currencyId, setCurrencyId] = useState('');
    const [inAppStatus, setInAppStatus] = useState('');
    const [inAppTransition, setInAppTransition] = useState(false);
    const [errorBusinessType, setErroBusinessType] = useState(false);
    const [errorName, setErrorName] = useState(false);
    const [commonError, setCommonError] = useState(false);
    const [errorMobile, setErrorMobile] = useState(false);
    const [errorEmail, setErrorEmail] = useState(false);
    const [errorGstType, setErrorGstType] = useState(false);
    const [errorGstCode, setErrorGstCode] = useState(false);
    // const [errorCountry, setErrorCountry] = useState(false);
    const [errorTcs, setErrorTcs] = useState(false);
    const [errorGstIn, setErrorGstIn] = useState(false);
    const [errorLanguage, setErrorLanguage] = useState(false);
    const [errorCurrency, setErrorCurrency] = useState(false);
    //const [errorClassification, setErrorClassification] = useState(false);
    const [errorContactForm, setErrorContactForm] = useState(false);
    const [erroremptyAlternateName, setErroremptyAlternateName] = useState(false);
    //const [erroremptyAlternateNumber, setErroremptyAlternateNumber] = useState(false);
    const [errorPincode, setErrorPincode] = useState(false);
    const [errorState, setErrorState] = useState(false);

    const [supplierBusinessId, setSupplierBusinessId] = useState('');

    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const [factBox, setFactBox] = useState([]);
    const [gstTypeList, setGstTypeList] = useState([]);
    const [taxTypeId, setTaxTypeId] = useState('');

    const priceRef = useRef('');
    const apiUrl = useState('purchase-prices');

    const menus = [
        {
            "name": "Payment Details",
            "link": `/purchase/purchase-management/all-suppliers/${AESEncrypt(decryptedId)}/paymentDetailsView`
        },
        {
            "name": "Create Order",
            "link": ""
        },
        {
            "name": "Create Self Bill",
            "link": `/purchase/purchase-management/self-bill/${AESEncrypt(decryptedId)}/create`
        },
        {
            "name": "Make Payment",
            "link": `/purchase/purchase-management/supplier-payment/${AESEncrypt(decryptedId)}/create`
        },
        {
            "name": "Invoice History",
            "link": `/purchase/transactions/${AESEncrypt(decryptedId)}/invoice-history`
        },
        {
            "name": "Order History",
            "link": ""
        },
        {
            "name": "Planned Orders",
            "link": ""
        },
        {
            "name": "Settlement",
            "link": `/purchase/report-and-enquiry/${AESEncrypt(decryptedId)}/supplier-settlement`
        },
        {
            "name": "Transaction History",
            "link": `/purchase/transactions/${AESEncrypt(decryptedId)}/supplier-transactions`
        }
    ];

    useEffect(() => {
        if (roleManagement !== '' && checkCRUDViewPermission('All Suppliers', 'edit', history, 'Purchase')) {
            loadTasks();
        }
        return () => {
            dispatch({ type: addressActions.CLEAR_ADDRESS_DETAILS_START });
            dispatch({ type: actions.CLEAR_PURCHASE_MANAGEMENT_DETAILS_START });
        }
    }, [roleManagement]);

    const handleKeyDown = (e) => {
        if (e.altKey && e.keyCode === 83) {
            if (!showDetails) {
                e.preventDefault();
                handleSubmit(e);
            }
        } else if (e.altKey && e.keyCode === 69) {
            e.preventDefault();
            history.push(`/purchase/purchase-management/all-suppliers/${AESEncrypt(decryptedId)}/edit`);
        } else if (e.altKey && e.keyCode === 66) {
            e.preventDefault();
            history.push(`/purchase/purchase-management/self-bill/${AESEncrypt(decryptedId)}/create`);
        } else if (e.altKey && e.keyCode === 84) {
            e.preventDefault();
            history.push(`/purchase/transactions/${AESEncrypt(decryptedId)}/supplier-transactions`);
        } else if (e.altKey && e.keyCode === 73) {
            e.preventDefault();
            history.push(`/purchase/transactions/${AESEncrypt(decryptedId)}/invoice-history`);
        } else if (e.altKey && e.keyCode === 80) {
            e.preventDefault();
            history.push(`/purchase/purchase-management/supplier-payment/${AESEncrypt(decryptedId)}/create`);
        } else if (e.altKey && e.keyCode === 77) {
            e.preventDefault();
            history.push(`/purchase/report-and-enquiry/${AESEncrypt(decryptedId)}/supplier-settlement`);
        }
    };

    useEventListener("keydown", handleKeyDown);

    const loadTasks = useCallback(() => {
        if (supplierId === undefined || decryptedId === 0) {
            history.push("/purchase/purchase-management/all-suppliers");
            return true;
        }
        dispatch({
            type: addressActions.STATE_DETAILS_START, url: 'state', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: addressActions.COUNTRY_DETAILS_START, url: 'country', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: groupActions.SUPPLIERGROUP_DETAILS_START, url: 'supplier-group', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: gstActions.TAXCODE_DETAILS_START, url: 'taxcode', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: gstActions.CASHDISCOUNT_DETAILS_START, url: 'cashdiscount', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: gstActions.OTHERTAXES_DETAILS_START, url: 'othertaxes', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: gstActions.PARTYGST_DETAILS_START, url: 'partygst', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: gstActions.CURRENCY_DETAILS_START, url: 'currency', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: addressActions.LANGUAGE_DETAILS_START, filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: gstActions.MOP_DETAILS_START, url: 'mop', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: productActions.MYPRODUCT_DETAILS_START, url: 'client-products', filter: {
                where: { "and": [{ status: 'ACTIVE' }] },
                order: 'id  desc'
            }
        });

        dispatch({ type: crudActions.READ_DETAILS_START, id: decryptedId, url: "supplierProfile" });

    });


    const handleChangeCountry = (value) => {
        setCountryId(value);
        setStateId('');
        setCityId('');
        setPincodeId('');
        setAreaId('');
        let a = countryDetails && countryDetails.filter(function (el) { return el.id === value });
        if (a && a?.length !== 0) {
            setCurrencyId(a[0].currencyId);
        }
        dispatch({
            type: younoteAdminSetupActions.TAX_TYPE_START,
            url: `/tax-types/byCountry/${value}`,
            // filter: {
            //     where: { countryTaxId: 1 }
            // }
        });
    }

    const emptyState = () => {
        setErroBusinessType(false);
        setErrorName(false);
        setCommonError(false);
        setErrorMobile(false);
        setErrorEmail(false);
        setErrorGstType(false);
        setErrorLanguage(false);
        setErrorCurrency(false);
        setErrorGstCode(false);
        setErrorContactForm(false);
        setErroremptyAlternateName(false);
        //setErroremptyAlternateNumber(false);
        setErrorGstIn(false);
        // setErrorCountry(false);
        setErrorPincode(false);
        setErrorState(false);
        setErrorTcs(false);
    }


    const handleSubmit = (e) => {
        e.preventDefault();
        childRef?.current?.handleAdjustHeight();
        let emptyGstIn = {};
        let emailCheck = true;
        let emptyBusinessType = emptyValidation('Business Type', businessType, 'dropDown');
        let emptyName = emptyValidation('Name', name);
        let emptyEmail = customEmailValidation('Email', email);
        if (email && !emptyEmail.isValid) {
            emailCheck = false;
        }
        let emptyMobile = emptyValidation('Mobile Number', mobile);
        let emptyTaxTypeId = emptyValidation('Gst Type', taxTypeId, 'dropDown');
        let emptyLanguage = emptyValidation('Language', languageId, 'dropDown');
        let emptyCurrency = emptyValidation('Currency', currencyId, 'dropDown');
        // let emptyClassification = emptyValidation('Classification', classification);
        //let emptyalternateMobile = customPhoneValidationOptional('Alternate Phone', alternateMobile);
        // let emptyContactName = customAlaphabetValidationOptional('Contact Name', contactName);
        // let emptyAlternateName = customAlaphabetValidationOptional('Alternate Name', tradingName);
        let emptyCountry = emptyValidation('Country', countryId, 'dropDown');
        let emptyPincode = emptyValidation('Pincode', pincodeId, 'dropDown');
        let emptyStateVal = emptyValidation('State', stateId, 'dropDown');

        let emptyGstCode = { isValid: true };
        if (taxTypeId !== '') {
            let a = taxType && taxType?.filter((el) => el.id === taxTypeId);
            if (a && a.length > 0 && (a[0].taxCode === 'UNRB' || a[0].taxCode === 'COMP' || a[0].taxCode === 'CONS')) {
                emptyGstIn = customAlaphaNumericValidationOptional('GST IN', gstin, 15);
            } else {
                emptyGstIn = customAlaphaNumericValidation('GST IN', gstin, 15);
            }

            if (a && a.length > 0) {
                if (a[0].taxCode === 'UNRB' || a[0].taxCode === 'COMP' || a[0].taxCode === 'CONS') {
                    emptyGstCode = { isValid: true }
                } else {
                    emptyGstCode = emptyValidation('Gst Code', gstCodeId, 'dropDown');
                }
            }
        }

        let emptyTcs = { isValid: true };
        if (tcs) {
            emptyTcs = emptyValidation('TCS', tcsId, 'dropDown');
        }

        emptyState();
        if (emptyBusinessType.isValid && emptyName.isValid && emailCheck && emptyMobile.isValid && emptyTaxTypeId.isValid
            && emptyLanguage.isValid && emptyCurrency.isValid && emptyGstCode.isValid
            && emptyGstIn.isValid && emptyPincode.isValid && emptyStateVal.isValid && emptyTcs.isValid) {
            let details = {
                ...readDetails,
                type: businessType,
                name: name,
                email: email,
                mobile: mobile,
                isHold: isHold,
                languageId: languageId,
                taxTypeId: taxTypeId,
                gstin: gstin || '',
                address1: address1 || '',
                contactName: contactName || '',
                tradingName: tradingName || '',
                countryId: countryId || '',
                alternateMobile: alternateMobile || '',
                currencyId: currencyId,
                inAppStatus: inAppStatus,
                priceIncludesTax: priceIncludesTax || false,
                taxCodeId: taxCodeId || 0,
                tcsId: tcsId || 0,
                tdsId: tdsId || 0,
                tcsBoolean: tcs || false,
                tdsBoolean: tds || false,
                cashDiscountId: cashDiscountId || 0
            }
            delete details.taxType;
            delete details.city;
            delete details.state;
            delete details.country;
            delete details.currency;
            delete details.language;
            delete details.pincode;
            delete details.partyGst;
            delete details.facts;
            delete details.business; delete details.taxCode;
            delete details.supplierBalance; delete details.supplierBusiness; delete details.cashDiscount; delete details.tcs;
            delete details.mop; delete details.area; delete details.group; delete details.pan;

            if (pan) {
                let ideType = identityType || 'PAN';
                details["pan"] = ideType + '-' + pan;
            } else {
                details["pan"] = '';
            }

            if (groupId) {
                details["groupId"] = groupId;
            } else {
                details["groupId"] = 0;
            }

            if (gstCodeId) {
                details["partyGstId"] = gstCodeId;
            } else {
                details["partyGstId"] = 0;
            }

            if (mopId) {
                details["mopId"] = mopId;
            } else {
                details["mopId"] = 0;
            }

            if (areaId) {
                details["areaId"] = areaId;
            } else {
                details["areaId"] = 0;
            }
            if (pincodeId) {
                details["pincodeId"] = pincodeId;
            } else {
                details["pincodeId"] = 0;
            }
            if (stateId) {
                details["stateId"] = stateId;
            } else {
                details["stateId"] = 0;
            }
            if (cityId) {
                details["cityId"] = cityId;
            } else {
                details["cityId"] = 0;
            }
            if (inAppStatus) {
                details["inAppStatus"] = inAppStatus;
            } else {
                details["inAppStatus"] = '';
            }

            if (supplierBusinessId) {
                details["supplierBusinessId"] = supplierBusinessId;
            } else {
                details["supplierBusinessId"] = 0;
            }

            details["inAppTransition"] = inAppTransition;
            if (classification) {
                details["classification"] = classification;
            } else {
                details["classification"] = '';
            }

            //let data = Object.fromEntries(Object.entries(details).filter(([_, v]) => v !== null));

            dispatch({
                type: crudActions.EDIT_DETAILS_START,
                id: decryptedId,
                url: "supplierProfile",
                title: "Supplier Profile",
                details: details,
                method: 'put'
            })
        } else {
            if (emptyBusinessType.errors) {
                setErroBusinessType(emptyBusinessType.errors);
            }
            if (emptyName.errors) {
                setErrorName(emptyName.errors);
            }
            if (emptyMobile.errors) {
                setErrorMobile(emptyMobile.errors);
            }
            if (email !== '' && emptyEmail.errors) {
                setErrorEmail(emptyEmail.errors);
            }
            if (emptyTaxTypeId.errors) {
                setErrorGstType(emptyTaxTypeId.errors);
            }

            if (emptyGstCode.errors) {
                setErrorGstCode(emptyGstCode.errors);
            }
            if (emptyTcs.errors) {
                setErrorTcs(emptyTcs.errors);
            }

            if (emptyLanguage.errors) {
                setErrorLanguage(emptyLanguage.errors);
            }
            if (emptyPincode.errors) {
                setErrorPincode(emptyPincode.errors);
            }
            if (emptyStateVal.errors) {
                setErrorState(emptyStateVal.errors);
            }
            if (emptyCountry.errors) {
                // setErrorCountry(emptyCountry.errors);
            }
            if (emptyCurrency.errors) {
                setErrorCurrency(emptyCurrency.errors);
            }

            // if (emptyClassification.errors) {
            //     setErrorClassification(emptyClassification.errors);
            // }
            // if (emptyContactName.errors) {
            //     setErrorContactForm(emptyContactName.errors);
            // }
            // if (emptyAlternateName.errors) {
            //     setErroremptyAlternateName(emptyAlternateName.errors);
            // }
            // if (emptyalternateMobile.errors) {
            //     setErroremptyAlternateNumber(emptyalternateMobile.errors);
            // }
            if (emptyGstIn.errors) {
                setErrorGstIn(emptyGstIn.errors);
            }
            scrollToError();
        }
    }

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            toast.dismiss();
            // toast(editDetails);
            if (roleManagement !== '' && checkCRUDPermission('All Suppliers', 'view', 'Purchase')) {
                history.push(`/purchase/purchase-management/all-suppliers/${AESEncrypt(decryptedId)}/view`, 'edit');
            } else {
                history.push(`/purchase/purchase-management/all-suppliers`);
            }
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let message = editError.error.message;
            toast.dismiss();
            toast.error(message);
        }
    }, [editDetails, editError]);

    useEffect(() => {
        if (countryId !== '') {
            setGstTypeList(taxType);
            if (taxTypeId === '' && taxType && taxType?.length > 0) {
                let a = taxType && taxType?.filter((el) => el.isDefault);
                if (a && a.length > 0) {
                    setTaxTypeId(a[0]?.id);
                }
            }
        }
    }, [countryId, taxType]);

    const handleChangeTransaction = (trans, details) => {
        setInAppTransition(trans);
        if (details?.inAppStatus === 'ACCEPTED') {
            if (!trans) {
                setInAppStatus('STOPPED');
            } else {
                setInAppStatus(details?.inAppStatus);
            }
        }

        if (details?.inAppStatus === 'NO' || details?.inAppStatus === 'REJECTED' || details?.inAppStatus === 'STOPPED') {
            if (trans) {
                setInAppStatus('REQUEST SENT');
            } else {
                setInAppStatus(details?.inAppStatus);
            }
        }
    }


    useEffect(() => {
        if (prevReadDetails !== undefined && readDetails && prevReadDetails !== readDetails) {
            if (readDetails?.stateId) {
                changeStateApi(readDetails?.stateId);
            }

            if (readDetails?.pincodeId) {
                dispatch({
                    type: addressActions.AREA_DETAILS_START, url: 'areas', filter: {
                        where: { ["and"]: [{ pincodeId: readDetails?.pincodeId }] }
                    }
                });
            }

            // let panArray = [];
            // if (readDetails?.pan) {
            //     panArray = readDetails?.pan.split("-");
            // }

            let identityType = '';
            let pan = '';

            if (readDetails?.pan) {
                const panArray = readDetails.pan.split('-').map(v => v.trim());

                identityType = panArray[0] || '';
                pan = panArray.slice(1).join('-') || '';
            }

            setSerialNumber(readDetails?.serialNo || '');
            setBusinessType(readDetails?.type || '');
            setName(readDetails?.name || '');
            setIsHold(readDetails?.isHold || false)
            setMobile(readDetails?.mobile || '');
            setEmail(readDetails?.email || '');
            setAddress1(readDetails.address1 || '');
            setPriceIncludesTax(readDetails?.priceIncludesTax || false);
            setClassification(readDetails?.classification || '');
            setLanguageId(readDetails?.languageId || '');
            setGroupId(readDetails?.groupId || '');
            setTaxTypeId(readDetails?.taxTypeId || '');
            setIdentityType(identityType);
            setPan(pan);
            setGstCodeId(readDetails.partyGstId > 0 ? readDetails.partyGstId : '');
            setGstin(readDetails?.gstin || '');
            setAreaId(readDetails?.areaId || '');
            setPincodeId(readDetails?.pincodeId);
            setCityId(readDetails?.cityId);
            setStateId(readDetails?.stateId);
            setCountryId(readDetails?.countryId);
            setContactName(readDetails?.contactName || '');
            setTradingName(readDetails?.tradingName || '');
            setAlternateMobile(readDetails?.alternateMobile || '');
            setMopId(readDetails.mopId > 0 ? readDetails.mopId : '');
            setCurrencyId(readDetails?.currencyId);
            setInAppStatus(readDetails.inAppStatus || "NO");
            setSupplierBusinessId(readDetails?.supplierBusinessId);
            setInAppTransition(readDetails?.inAppTransition || false);
            setTaxCodeId(readDetails?.taxCodeId || '');
            setCashDiscountId(readDetails?.cashDiscountId || '');
            setTcsId(readDetails?.tcsId || '');
            setTcs(readDetails?.tcsBoolean || false);
            setTds(readDetails?.tdsBoolean || false);
            dispatch({
                type: younoteAdminSetupActions.TAX_TYPE_START,
                url: `/tax-types/byCountry/${readDetails.countryId}`,
                // filter: {
                //     where: { countryTaxId: 1 }
                // }
            });
            if (readDetails?.isHold) {
                menus.splice(2, 2);
            }
            if (readDetails?.facts) {
                setFactBox(readDetails.facts);
                if (readDetails?.isNew) {
                    let iH = menus.findIndex((d, i) => d.name === 'Invoice History');
                    menus[iH]['disabled'] = true;
                    let oH = menus.findIndex((d, i) => d.name === 'Order History');
                    menus[oH]['disabled'] = true;
                    let s = menus.findIndex((d, i) => d.name === 'Settlement');
                    menus[s]['disabled'] = true;
                    let tH = menus.findIndex((d, i) => d.name === 'Transaction History');
                    menus[tH]['disabled'] = true;
                    let pO = menus.findIndex((d, i) => d.name === 'Planned Orders');
                    menus[pO]['disabled'] = true;
                }
                setTimeout(function () {
                    dispatch({ type: qucikLinksActions.QUICKLINKS_START, menus: menus, toggle: true, factBox: readDetails.facts, component: "All Suppliers" });
                    childRef?.current?.handleAdjustHeight();
                }, 200)
            }
            setShowDetails(false);
        }
    }, [readDetails, readError]);

    const changeArea = (value) => {
        setAreaId(value);
    }

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const changePincode = (value) => {
        setPincodeId(value);
        setAreaId('');
        let a = pincodeDetails && pincodeDetails.filter(function (el) { return el.id === value });
        if (a && a?.length !== 0) {
            setCityId(a[0].cityId);
            dispatch({
                type: addressActions.AREA_DETAILS_START, url: 'areas', filter: {
                    where: { ["and"]: [{ pincodeId: value }] }
                }
            });
        }
    }


    const changeCity = (value) => {
        setCityId(value);
        setAreaId('');
        setPincodeId('');
    }

    const changeState = (value) => {
        setStateId(value);
        setCityId('');
        setPincodeId('');
        setAreaId('');
        let a = stateDetails && stateDetails.filter(function (el) { return el.id === value });
        if (a && a?.length !== 0) {
            setCountryId(a[0].countryId);
            setCurrencyId(a[0].country && a[0].country.currencyId);
            dispatch({
                type: younoteAdminSetupActions.TAX_TYPE_START,
                url: `/tax-types/byCountry/${a[0].countryId}`,
                // filter: {
                //     where: { countryTaxId: 1 }
                // }
            });
        }
        changeStateApi(value);
    }

    const changeStateApi = (value) => {
        dispatch({
            type: addressActions.PINCODE_DETAILS_START, url: 'pincode', filter: {
                where: { ["and"]: [{ stateId: value }] }
            }
        });
        dispatch({
            type: addressActions.CITY_DETAILS_START, url: 'city', filter: {
                where: { ["and"]: [{ stateId: value }] }
            }
        });
    }

    const handlePartyGstDetails = () => {
        let result = partyGstdetails;
        if (taxTypeId !== '' && taxType && taxType.length > 0) {
            let a = taxType && taxType?.filter((el) => el.id === taxTypeId);
            if (a && a.length > 0 && a[0]?.taxCode === 'SPEZ') {
                result = partyGstdetails.filter((el) => { return el.isSEZ })
            }
        }
        return result;
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props}
                img={PurchaseIcon}
                title={'Purchase'}
                closeLink={'/purchase/purchase-management/all-suppliers'}
                links={[{ 'label': 'Purchase', 'link': '/purchase' }, { 'label': 'All Suppliers', 'link': '/purchase/purchase-management/all-suppliers' }, { 'label': 'Supplier Details', 'link': '' }]}
            />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.listTableSticky, { [classes.scrollBorder]: !showDetails })}>
                <div id="containerDiv" className={clsx(classes.stickyContainer)}>
                    <CustomAccordion
                        title={'Edit Supplier'}
                        top={"0"}
                        topVisible={"50px"}
                        zIndex={9}
                        showDetails={showDetails}
                        index={0}
                        ref={childRef}
                        component={
                            <>
                                {
                                    readLoader === false && readDetails &&
                                    <Box
                                        className={clsx(classes.removeUnderline)}
                                        component="form"
                                        autoComplete="off"
                                        onSubmit={(e) => handleSubmit(e)}>
                                        <Row>
                                            {
                                                commonError &&
                                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={classes.textAlignCenter}><CustomAlert error={commonError} customClass={clsx(classes.uploadError)} />
                                                </Col>
                                            }
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold)}
                                                >General</Typography>
                                            </Col>
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className={classes.textAlignRight}>
                                                <Button
                                                    tabIndex={-1}
                                                    type='submit'
                                                    color='primary'
                                                    variant="contained"
                                                    id={idNamingConversion('Submit', 'supplierProfile', 'Button')}
                                                    className={clsx(classes.modalBtn, { [classes.loading]: editLoader })}>
                                                    Update
                                                </Button>
                                            </Col>
                                        </Row>
                                        <Row gutter={50}>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <AutoCompleteComponent
                                                    name={["Business Type ", <span key={"Business Type"} className={classes.colorRedRequired}> *</span>]}
                                                    heads={[{ 'key': 'label', 'name': 'Name' }]}
                                                    details={customerTypeList}
                                                    parentValue={customObject(customerTypeList, businessType)}
                                                    onChange={(data) => setBusinessType(data.id)}
                                                    position={"bottom"}
                                                    id={idNamingConversion('Business Type', 'supplierProfile', 'DropDown')}
                                                    customClasses={classes.margin20t}
                                                    parentError={errorBusinessType}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin20t, 'MuiInputLabel-shrink', classes.fonSize13)}>Supplier ID</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{serialNumber ? serialNumber : '---'}</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <TextField autoComplete='one-time-code'
                                                    label={["Supplier Name ", <span key={"Supplier Name"} className={classes.colorRedRequired}> *</span>]}
                                                    fullWidth
                                                    error={errorName && true}
                                                    helperText={errorName}
                                                    value={name}
                                                    id={idNamingConversion('Supplier Name', 'supplierProfile', 'TextField')}
                                                    className={classes.margin20t}
                                                    variant={'standard'}
                                                    InputProps={{
                                                        classes: {
                                                            input: classes.textFieldColor,
                                                        }
                                                    }}
                                                    InputLabelProps={{
                                                        className: classes.textFieldLableColorCustom
                                                    }}
                                                    onChange={(e) => setName(e.target.value)}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <FormControlLabel
                                                    classes={{
                                                        label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink') // Pass your override css here
                                                    }}
                                                    id={idNamingConversion('Hold', 'supplierProfile', 'Radio')}
                                                    control={<Switch size='small'
                                                        className={clsx(classes.customSwitch)}
                                                        onChange={(e) => setIsHold(!isHold)}
                                                        checked={isHold}
                                                    />}
                                                    label="Hold"
                                                    labelPlacement="top"
                                                    className={clsx(classes.marginLeft0, classes.flexStart, classes.margin20t)}
                                                />
                                            </Col>
                                            <Col xxl={4} xl={4} lg={6} md={8} sm={12} xs={24}>
                                                <FormControlLabel
                                                    classes={{
                                                        label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink') // Pass your override css here
                                                    }}
                                                    id={idNamingConversion('Price Include Tax', 'supplierProfile', 'Radio')}
                                                    control={<Switch size='small'
                                                        className={clsx(classes.customSwitch)}
                                                        onChange={(e) => setPriceIncludesTax(!priceIncludesTax)}
                                                        checked={priceIncludesTax}
                                                    />}
                                                    label="Price Includes Tax"
                                                    labelPlacement="top"
                                                    className={clsx(classes.marginLeft0, classes.flexStart, classes.margin20t)}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <TextField autoComplete='one-time-code'
                                                    label={["Mobile Number ", <span key={"Mobile Number"} className={classes.colorRedRequired}> *</span>]}
                                                    fullWidth
                                                    // type='number'
                                                    id={idNamingConversion('Mobile Number', 'supplierProfile', 'TextField')}
                                                    error={errorMobile && true}
                                                    helperText={errorMobile}
                                                    value={mobile}
                                                    variant={'standard'}
                                                    className={clsx(classes.margin20t)}
                                                    InputProps={{
                                                        classes: {
                                                            input: classes.textFieldColor,
                                                        }
                                                    }}
                                                    onWheel={(e) => e.target.blur()}
                                                    InputLabelProps={{
                                                        className: classes.textFieldLableColorCustom
                                                    }}
                                                    //onKeyDown={(e) => handleKeyDown(e)}
                                                    onChange={(e) => setMobile(e.target.value)}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <TextField autoComplete='one-time-code'
                                                    label='Email'
                                                    fullWidth
                                                    value={email}
                                                    id={idNamingConversion('Email', 'supplierProfile', 'TextField')}
                                                    error={errorEmail && true}
                                                    helperText={errorEmail}
                                                    variant={'standard'}
                                                    className={clsx(classes.margin20t)}
                                                    InputProps={{
                                                        classes: {
                                                            input: classes.textFieldColor,
                                                        }
                                                    }}
                                                    InputLabelProps={{
                                                        className: classes.textFieldLableColorCustom,
                                                    }}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <AutoCompleteComponent
                                                    name={"Classification "}
                                                    heads={[{ 'key': 'label', 'name': 'Name' }]}
                                                    details={classificationList}
                                                    parentValue={customObject(classificationList, classification)}
                                                    onChange={(data) => setClassification(data.id)}
                                                    position={"bottom"}
                                                    id={idNamingConversion('Classification', 'supplierProfile', 'DropDown')}
                                                    customClasses={classes.margin20t}
                                                    onChangeText={(value) => {
                                                        if (value === '') {
                                                            setClassification('')
                                                        }
                                                    }}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <AutoCompleteComponent
                                                    name={["Preferred Language ", <span key={"Preferred Language"} className={classes.colorRedRequired}> *</span>]}
                                                    heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                    details={languageDetails}
                                                    id={idNamingConversion('Preferred Language', 'supplierProfile', 'DropDown')}
                                                    parentValue={customObject(languageDetails, languageId)}
                                                    onChange={(data) => setLanguageId(data.id)}
                                                    position={"bottom"}
                                                    parentError={errorLanguage}
                                                    customClasses={classes.margin20t}
                                                />
                                            </Col>
                                            <Col xxl={4} xl={4} lg={6} md={8} sm={12} xs={24}>
                                                <AutoCompleteComponent
                                                    name={["Group "]}
                                                    id={idNamingConversion('Group', 'supplierProfile', 'DropDown')}
                                                    heads={[{ 'key': 'name', 'name': 'Name' },
                                                    { 'key': 'description', 'name': 'Description' }]}
                                                    details={supplierGroupDetails}
                                                    parentValue={customObject(supplierGroupDetails, groupId)}
                                                    onChange={(data) => setGroupId(data.id)}
                                                    position={"bottom"}
                                                    onChangeText={(value) => {
                                                        if (value === '') {
                                                            setGroupId('')
                                                        }
                                                    }}
                                                    customClasses={classes.margin20t}
                                                />
                                            </Col>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <Typography variant={'h6'} className={clsx(classes.customLink, classes.margin35t, classes.typographyHeader, classes.bold)}>GST Details</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <AutoCompleteComponent
                                                    name={["GST Type ", <span key={"GST Type"} className={classes.colorRedRequired}> *</span>]}
                                                    heads={[{ 'key': 'name', 'name': 'Name' },
                                                    { 'key': 'taxCode', 'name': 'Code' }]}
                                                    details={gstTypeList}
                                                    id={idNamingConversion('GST Type', 'supplierProfile', 'DropDown')}
                                                    parentValue={customObject(gstTypeList, taxTypeId)}
                                                    onChange={(data) => {
                                                        setTaxTypeId(data.id);
                                                        setGstCodeId(data?.partyGstId || '');
                                                    }}
                                                    parentError={errorGstType}
                                                    position={"bottom"}
                                                    customClasses={clsx(classes.margin20t, classes.dropDownPointer)}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <AutoCompleteComponent
                                                    name={["Party GST Code "]}
                                                    heads={[{ 'key': 'code', 'name': 'Party GST Code' },
                                                    { 'key': 'description', 'name': 'Description' }]}
                                                    details={handlePartyGstDetails()}
                                                    id={idNamingConversion('Party GST Code', 'supplierProfile', 'DropDown')}
                                                    parentValue={customObject(handlePartyGstDetails(), gstCodeId)}
                                                    onChange={(data) => setGstCodeId(data.id)}
                                                    parentError={errorGstCode}
                                                    position={"bottom"}
                                                    customClasses={classes.margin20t}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <TextField autoComplete='one-time-code'
                                                    label='GST Number (GSTIN)'
                                                    fullWidth
                                                    error={errorGstIn && true}
                                                    helperText={errorGstIn}
                                                    value={gstin}
                                                    id={idNamingConversion('GST Number', 'supplierProfile', 'TextField')}
                                                    variant={'standard'}
                                                    className={clsx(classes.margin20t)}
                                                    title={'A GSTIN is a 15-digit PAN-based unique identification number allotted to every registered person under GST'}
                                                    InputProps={{
                                                        classes: {
                                                            input: classes.textFieldColor,
                                                        }
                                                    }}
                                                    InputLabelProps={{
                                                        className: classes.textFieldLableColorCustom,
                                                    }}
                                                    onChange={(e) => setGstin(e.target.value)}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <FormControl
                                                    tabIndex={-1}
                                                    className={clsx(classes.margin20t, classes.dropDownPointer, classes.customRadioButton, classes.customIdentityRadioButton)}
                                                    variant={'standard'}
                                                    fullWidth>
                                                    <FormLabel className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Identity Type</FormLabel>
                                                    <RadioGroup row
                                                        defaultValue={"PAN"}
                                                        aria-labelledby="demo-customized-radios"
                                                        name="identityType"
                                                        value={identityType || "PAN"}
                                                        onChange={(e) => setIdentityType(e.target.value)}>
                                                        <FormControlLabel value={"PAN"} control={<Radio
                                                            checkedIcon={<UnSelectedIcon />}
                                                            icon={<SelectedIcon />}
                                                        />} label="PAN" />
                                                        <FormControlLabel value={"TAN"} control={<Radio
                                                            checkedIcon={<UnSelectedIcon />}
                                                            icon={<SelectedIcon />}
                                                        />} label="TAN" />
                                                        <FormControlLabel value={"CIN"} control={<Radio
                                                            checkedIcon={<UnSelectedIcon />}
                                                            icon={<SelectedIcon />}
                                                        />} label="CIN" />
                                                        <FormControlLabel value={'LIC'} control={<Radio
                                                            checkedIcon={<UnSelectedIcon />}
                                                            icon={<SelectedIcon />}
                                                        />} label="License Number" />
                                                    </RadioGroup>
                                                </FormControl>
                                            </Col>
                                            <Col xxl={4} xl={4} lg={6} md={8} sm={12} xs={24}>
                                                <TextField autoComplete='one-time-code'
                                                    label={`${identityType || "PAN"} Number`}
                                                    fullWidth
                                                    id={idNamingConversion("PAN Number", 'customerProfile', 'TextField')}
                                                    value={pan}
                                                    variant={'standard'}
                                                    className={clsx(classes.margin20t)}
                                                    InputProps={{
                                                        classes: {
                                                            input: classes.textFieldColor,
                                                        }
                                                    }}
                                                    InputLabelProps={{
                                                        className: classes.textFieldLableColorCustom,
                                                    }}
                                                    onChange={(e) => setPan(e.target.value)}
                                                />
                                            </Col>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <Typography variant={'h6'} className={clsx(classes.customLink, classes.typographyHeaderToolTip, classes.margin35t, classes.typographyHeader, classes.bold)}>
                                                    <span>Address</span>
                                                    <Tooltip
                                                        classes={{ popper: clsx(classes.customToolTip, classes.customToolTipWidth) }}
                                                        title={'Billing Address'} arrow placement="top" className={classes.tooltip}>
                                                        <IconButton>
                                                            <Image src={infoMarkIcon} preview={false} />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <AutoCompleteComponent
                                                    name={["State/Province ", <span key={"State/Province"} className={classes.colorRedRequired}> *</span>]}
                                                    heads={[{ 'key': 'name', 'name': 'State Name' },
                                                    { 'key': 'country', 'name': 'Country Name', 'relation': 'name' }]}
                                                    details={stateDetails}
                                                    id={idNamingConversion('State', 'supplierProfile', 'DropDown')}
                                                    parentValue={customObject(stateDetails, stateId)}
                                                    onChange={(data) => changeState(data.id)}
                                                    position={"top"}
                                                    parentError={errorState}
                                                    customClasses={classes.margin20t}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <AutoCompleteComponent
                                                    name={["Pincode ", <span key={"Pincode"} className={classes.colorRedRequired}> *</span>]}
                                                    heads={[{ 'key': 'code', 'name': 'Pincode' },
                                                    { 'key': 'city', 'name': 'City', 'relation': 'name' }]}
                                                    details={pincodeDetails}
                                                    id={idNamingConversion('Pincode', 'supplierProfile', 'DropDown')}
                                                    parentValue={customObject(pincodeDetails, pincodeId)}
                                                    onChange={(data) => changePincode(data.id)}
                                                    position={"top"}
                                                    customClasses={classes.margin20t}
                                                    parentError={errorPincode}
                                                />
                                            </Col>
                                            <Col xxl={14} xl={14} lg={14} md={14} sm={14} xs={14}></Col>
                                            <Col xxl={10} xl={10} lg={24} md={24} sm={24} xs={24}>
                                                <Row gutter={50}>
                                                    <Col xxl={12} xl={12} lg={6} md={8} sm={12} xs={24}>
                                                        <TextField autoComplete='one-time-code'
                                                            label=''
                                                            value={address1}
                                                            id={idNamingConversion('Address', 'supplierProfile', 'TextField')}
                                                            placeholder='Door/Building Number,&#10;Building Name&#10;Street Address&#10;Locality'
                                                            variant={'outlined'}
                                                            className={clsx(classes.margin20t, classes.customDescription)}
                                                            fullWidth
                                                            multiline
                                                            name={"address"}
                                                            rows={6}
                                                            InputProps={{
                                                                classes: {
                                                                    input: classes.textFieldColor,
                                                                },
                                                                style: { height: 170 },
                                                            }}
                                                            InputLabelProps={{
                                                                className: classes.textFieldLableColor,
                                                            }}
                                                            onChange={(e) => setAddress1(e.target.value)}
                                                        />
                                                    </Col>
                                                    <Col xxl={12} xl={12} lg={6} md={8} sm={12} xs={24}>
                                                        <AutoCompleteComponent
                                                            name={["Area"]}
                                                            heads={[{ 'key': 'name', 'name': 'Area Name' },
                                                            { 'key': 'pincode', 'name': 'Pincode', 'relation': 'code' },
                                                            { 'key': 'city', 'name': 'City', 'relation': 'name' },
                                                            { 'key': 'state', 'name': 'State', 'relation': 'shortName' }]}
                                                            details={areaDetails}
                                                            id={idNamingConversion('Area', 'supplierProfile', 'DropDown')}
                                                            parentValue={customObject(areaDetails, areaId)}
                                                            onChange={(data) => { changeArea(data.id) }}
                                                            position={"top"}
                                                            customClasses={classes.margin20t}
                                                            customLink={'/admin/address/area'}
                                                            linkText={'Go to Area'}
                                                            infoMark={'Select the local postal area from the list or Goto Area master to create a new record for the missing area info. The field is optional and will take blank values.'}
                                                        />
                                                        <AutoCompleteComponent
                                                            name={["Dist/City/Town"]}
                                                            heads={[{ 'key': 'name', 'name': 'Name' },
                                                            { 'key': 'state', 'name': 'State Name', 'relation': 'shortName' }]}
                                                            details={cityDetails}
                                                            id={idNamingConversion('City', 'supplierProfile', 'DropDown')}
                                                            parentValue={customObject(cityDetails, cityId)}
                                                            onChange={(data) => changeCity(data.id)}
                                                            position={"top"}
                                                            customClasses={classes.margin20t}
                                                        />
                                                        <AutoCompleteComponent
                                                            name={["Country"]}
                                                            heads={[{ 'key': 'name', 'name': 'Country Name' }]}
                                                            details={countryDetails}
                                                            id={idNamingConversion('Country', 'supplierProfile', 'DropDown')}
                                                            parentValue={customObject(countryDetails, countryId)}
                                                            onChange={(data) => handleChangeCountry(data.id)}
                                                            position={"top"}
                                                            customClasses={classes.margin20t}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <Typography variant={'h6'} className={clsx(classes.customLink, classes.margin35t, classes.typographyHeader, classes.bold)}>Other Contact Details</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <TextField autoComplete='one-time-code'
                                                    fullWidth
                                                    error={errorContactForm && true}
                                                    helperText={errorContactForm}
                                                    label='Contact Name'
                                                    value={contactName}
                                                    variant={'standard'}
                                                    className={clsx(classes.margin20t)}
                                                    InputProps={{
                                                        classes: {
                                                            input: classes.textFieldColor,
                                                        }
                                                    }}
                                                    id={idNamingConversion('Contact Name', 'supplierProfile', 'TextField')}
                                                    InputLabelProps={{
                                                        className: classes.textFieldLableColorCustom,
                                                    }}
                                                    onChange={(e) => setContactName(e.target.value)}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <TextField autoComplete='one-time-code'
                                                    label='Alternate Name (Optional)'
                                                    fullWidth
                                                    error={erroremptyAlternateName && true}
                                                    helperText={erroremptyAlternateName}
                                                    value={tradingName}
                                                    variant={'standard'}
                                                    id={idNamingConversion('Alternate Name', 'supplierProfile', 'TextField')}
                                                    className={clsx(classes.margin20t)}
                                                    InputProps={{
                                                        classes: {
                                                            input: classes.textFieldColor,
                                                        }
                                                    }}
                                                    InputLabelProps={{
                                                        className: classes.textFieldLableColorCustom,
                                                    }}
                                                    onChange={(e) => setTradingName(e.target.value)}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <TextField autoComplete='one-time-code'
                                                    label='Alternate Phone'
                                                    // error={erroremptyAlternateNumber && true}
                                                    // helperText={erroremptyAlternateNumber}
                                                    value={alternateMobile}
                                                    type='number'
                                                    fullWidth
                                                    variant={'standard'}
                                                    id={idNamingConversion('Alternate Phone', 'supplierProfile', 'TextField')}
                                                    className={clsx(classes.margin20t)}
                                                    InputProps={{
                                                        classes: {
                                                            input: classes.textFieldColor,
                                                        }
                                                    }}
                                                    onWheel={(e) => e.target.blur()}
                                                    InputLabelProps={{
                                                        className: classes.textFieldLableColorCustom,
                                                    }}
                                                    onChange={(e) => setAlternateMobile(e.target.value)}
                                                />
                                            </Col>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <Typography variant={'h6'} className={clsx(classes.customLink, classes.margin35t, classes.typographyHeader, classes.bold)}>Payment Info</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <AutoCompleteComponent
                                                    name={["Method of payment (MOP)"]}
                                                    heads={[{ 'key': 'method', 'name': 'Method' },
                                                    { 'key': 'description', 'name': 'Description' }]}
                                                    details={mopDetails}
                                                    parentValue={customObject(mopDetails, mopId)}
                                                    onChange={(data) => setMopId(data.id)}
                                                    position={"top"}
                                                    onChangeText={(value) => {
                                                        if (value === '') {
                                                            setMopId('')
                                                        }
                                                    }}
                                                    id={idNamingConversion('Method of payment', 'supplierProfile', 'DropDown')}
                                                    customClasses={classes.margin20t}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <AutoCompleteComponent
                                                    name={["Currency ", <span key={"Currency"} className={classes.colorRedRequired}> *</span>]}
                                                    heads={[{ 'key': 'name', 'name': 'Currency Name' },
                                                    { 'key': 'shortName', 'name': 'Currency Short Form' }]}
                                                    details={currencyDetails}
                                                    parentValue={customObject(currencyDetails, currencyId)}
                                                    onChange={(data) => setCurrencyId(data.id)}
                                                    parentError={errorCurrency}
                                                    position={"top"}
                                                    id={idNamingConversion('Currency', 'supplierProfile', 'DropDown')}
                                                    customClasses={classes.margin20t}
                                                />
                                            </Col>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <Typography variant={'h6'} className={clsx(classes.customLink, classes.margin35t, classes.typographyHeader, classes.bold)}>Younote Info</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={8} xs={24} className={classes.margin20t}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Younote ID</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails?.supplierBusiness?.serialNo || '---'}</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={8} xs={24} className={classes.margin20t}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>In-App Status</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.inAppStatus ? capitalizeFirstLetter(readDetails.inAppStatus) : 'No'}</Typography>
                                            </Col>
                                            <Col xxl={14} xl={14} lg={6} md={8} sm={8} xs={24} className={classes.margin20t}>
                                                <FormControlLabel
                                                    classes={{
                                                        label: clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13) // Pass your override css here
                                                    }}
                                                    control={<Switch size='small' className={clsx(classes.customSwitch)}
                                                        onChange={(e) => handleChangeTransaction(!inAppTransition, readDetails)} />
                                                    }
                                                    id={idNamingConversion('In-AppTransactions', 'supplierProfile', 'Radio')}
                                                    label="In-AppTransactions"
                                                    checked={inAppTransition}
                                                    labelPlacement="top"
                                                    disabled={supplierBusinessId ? inAppStatus === 'REQUEST SENT' ? true : false : true}
                                                    className={clsx(classes.marginLeft0, classes.flexStart)}
                                                />
                                            </Col>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>
                                                    Other Taxes</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <AutoCompleteComponent
                                                    name={["Cash Discount"]}
                                                    heads={[{ 'key': 'code', 'name': 'Code' }]}
                                                    details={cashDiscountDetails || []}
                                                    id={idNamingConversion('Cash Discount', 'customerProfile', 'DropDown')}
                                                    parentValue={customObject(cashDiscountDetails || [], cashDiscountId)}
                                                    onChange={(data) => setCashDiscountId(data.id)}
                                                    position={"top"}
                                                    customClasses={classes.margin20t}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <AutoCompleteComponent
                                                    name={["Tax Code "]}
                                                    heads={[{ 'key': 'code', 'name': 'Code' }]}
                                                    details={taxCodedetails}
                                                    id={idNamingConversion('Tax Code', 'customerProfile', 'DropDown')}
                                                    parentValue={customObject(taxCodedetails, taxCodeId)}
                                                    onChange={(data) => setTaxCodeId(data.id)}
                                                    position={"top"}
                                                    customClasses={classes.margin20t}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={8} xs={24}>
                                                <FormControlLabel
                                                    classes={{
                                                        label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink') // Pass your override css here
                                                    }}
                                                    id={idNamingConversion('TCS', 'customerProfile', 'Radio')}
                                                    control={<Switch size='small'
                                                        className={clsx(classes.customSwitch)}
                                                        onChange={(e) => setTcs(!tcs)}
                                                        checked={tcs}
                                                    />}
                                                    label="TCS"
                                                    labelPlacement="top"
                                                    className={clsx(classes.marginLeft0, classes.flexStart, classes.margin20t)}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={8} xs={24}>
                                                <FormControlLabel
                                                    classes={{
                                                        label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink') // Pass your override css here
                                                    }}
                                                    id={idNamingConversion('TDS', 'customerProfile', 'Radio')}
                                                    control={<Switch size='small'
                                                        className={clsx(classes.customSwitch)}
                                                        onChange={(e) => setTds(!tds)}
                                                        checked={tds}
                                                    />}
                                                    label="TDS"
                                                    labelPlacement="top"
                                                    className={clsx(classes.marginLeft0, classes.flexStart, classes.margin20t)}
                                                />
                                            </Col>
                                            {
                                                tcs && <Col xxl={4} xl={4} lg={6} md={8} sm={12} xs={24}>
                                                    <AutoCompleteComponent
                                                        name={["TCS "]}
                                                        heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                        details={(otherTaxesdetails || []).filter(el => el.taxType === 'TCS')}
                                                        id={idNamingConversion('TCS', 'customerProfile', 'DropDown')}
                                                        parentValue={customObject((otherTaxesdetails || []).filter(el => el.taxType === 'TCS'), tcsId)}
                                                        onChange={(data) => setTcsId(data.id)}
                                                        position={"top"}
                                                        customClasses={classes.margin20t}
                                                        parentError={errorTcs}
                                                    />
                                                </Col>
                                            }
                                        </Row>
                                    </Box>
                                }
                                {
                                    (readLoader === true) && (
                                        <div className={classes.textAlignCenter}>
                                            <div className={classes.loadMoreCircle}></div>
                                        </div>
                                    )
                                }
                            </>
                        }
                    />
                    <CustomAccordion
                        title={'Purchase Price Details'}
                        top={"49"}
                        topVisible={"150px"}
                        zIndex={7}
                        showDetails={showDetails}
                        index={1}
                        ref={childRef}
                        component={
                            <>
                                {
                                    readLoader === false ? readDetails &&
                                        <PurchasePrice topBarView={false}
                                            ref={priceRef}
                                            supplierId={decryptedId}
                                            groupId={readDetails?.groupId}
                                            title={"Purachase Price"}
                                            {...props}
                                            apiUrl={apiUrl} heads={PurchasePriceHead} /> : <div className={classes.textAlignCenter}>
                                        <div className={classes.loadMoreCircle}></div>
                                    </div>
                                }
                            </>
                        }
                    />
                    {/* <CustomAccordion
                        title={'Supplier Products'}
                        top={"113"}
                        topVisible={"250px"}
                        zIndex={5}
                        showDetails={showDetails}
                        index={2}
                        ref={childRef}
                        component={
                            <>
                            </>
                        }
                    />
                    <CustomAccordion
                        title={'Minimum Stock Quantity'}
                        top={"178"}
                        topVisible={"300px"}
                        zIndex={3}
                        showDetails={showDetails}
                        index={3}
                        ref={childRef}
                        component={
                            <>
                            </>
                        }
                        lastContent={true}
                    /> */}
                </div>
            </div>
            <QuickLinks menus={menus} factBox={factBox} component={"All Suppliers"} onParentFunction={() => childRef?.current?.handleAdjustHeight()}></QuickLinks>
        </React.Fragment >
    )
}
export default SupplierEdit